import sortBy from 'lodash/sortBy';

import { types as actions } from '../actions';

const defaultState = {
  list: [],
  map: {},
  currentCategory: {},
  filter: ''
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.GET_AREAS:
      return {
        ...defaultState
      };
    case actions.SET_CATEGORIES:
      return {
        list: sortBy(action.categories, [category => category.name.toLowerCase()]),
        map: action.categories.reduce(
          (map, category) => ({ ...map, [category.id]: category }),
          {}
        )
      };
    case actions.ADDED_CATEGORY: {
      return {
        list: sortBy([...state.list, action.category], [category => category.name.toLowerCase()]),
        map: {
          ...state.map,
          [action.category.id]: action.category
        }
      };
    }
    case actions.EDITED_CATEGORY: {
      const categoryList = state.list.map(category => {
        if (category.id === action.category.id) {
          category = action.category;
        }
        return category;
      });
      return {
        list: sortBy(categoryList, [category => category.name.toLowerCase()]),
        map: {
          ...state.map,
          [action.category.id]: action.category
        }
      };
    }
    case actions.SET_CURRENT_CATEGORY: {
      return {
        ...state,
        currentCategory: action.category
      };
    }
    case actions.REMOVE_CATEGORY: {
      const categoryList = state.list.filter(category => {
        return category.id !== action.category.id;
      });
      delete state.map[action.category.id];
      return {
        ...state,
        list: categoryList
      };
    }
    case actions.FILTER_CATEGORY: {
      return {
        ...state,
        filter: action.searchText
      };
    }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/categories/index.js